import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.w6n_1 = id;
        this.x6n_1 = name;
        this.y6n_1 = email;
        this.z6n_1 = badge;
        this.a6o_1 = callSignAdjective;
        this.b6o_1 = callSignNoun;
        this.c6o_1 = imageURL;
        this.d6o_1 = avatarType;
        this.e6o_1 = unvalidatedEmails;
        this.f6o_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.w6n_1.toString() + ', name=' + this.x6n_1 + ', email=' + this.y6n_1 + ', badge=' + toString(this.z6n_1) + ', callSignAdjective=' + this.a6o_1 + ', callSignNoun=' + this.b6o_1 + ', imageURL=' + toString(this.c6o_1) + ', avatarType=' + toString(this.d6o_1) + ', unvalidatedEmails=' + toString(this.e6o_1) + ', pins=' + toString(this.f6o_1) + ')';
      }
      hashCode() {
        var result = this.w6n_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.x6n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y6n_1) | 0;
        result = imul(result, 31) + hashCode(this.z6n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b6o_1) | 0;
        result = imul(result, 31) + hashCode(this.c6o_1) | 0;
        result = imul(result, 31) + hashCode(this.d6o_1) | 0;
        result = imul(result, 31) + hashCode(this.e6o_1) | 0;
        result = imul(result, 31) + hashCode(this.f6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.w6n_1.equals(other.w6n_1))
          return false;
        if (!(this.x6n_1 === other.x6n_1))
          return false;
        if (!(this.y6n_1 === other.y6n_1))
          return false;
        if (!equals(this.z6n_1, other.z6n_1))
          return false;
        if (!(this.a6o_1 === other.a6o_1))
          return false;
        if (!(this.b6o_1 === other.b6o_1))
          return false;
        if (!equals(this.c6o_1, other.c6o_1))
          return false;
        if (!equals(this.d6o_1, other.d6o_1))
          return false;
        if (!equals(this.e6o_1, other.e6o_1))
          return false;
        if (!equals(this.f6o_1, other.f6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
